(function() {
  'use strict';

  angular
    .module('service.surveyServiceFactory', ['service.survey'])
    .factory('SurveyServiceFactory', SurveyServiceFactory);

  SurveyServiceFactory.$inject = ['$injector'];

  function SurveyServiceFactory($injector) {
    var service = {
      getSurveyService: getSurveyService
    };

    return service;

    function getSurveyService(isPreview) {
      return isPreview ? $injector.get('PreviewSurveyService') : $injector.get('SurveyService');
    }
  }
})();
